import { render } from "./AnswerList.vue?vue&type=template&id=32be2574&scoped=true&ts=true"
import script from "./AnswerList.vue?vue&type=script&lang=ts"
export * from "./AnswerList.vue?vue&type=script&lang=ts"

import "./AnswerList.vue?vue&type=style&index=0&id=32be2574&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32be2574"]])

export default __exports__